import { Observable } from "rxjs";
import { Alert } from "../alert";
import { Loading } from "../loading";
import { LoadingType } from "../loading-type-enum";

export abstract class AlertGateway {
    abstract showAlert(messageAlert: Alert): void;
    abstract setLoading(showLoading: boolean, loadingType: LoadingType, textsLoading: Array<string>): void;
    abstract onAlert(id: any): Observable<Alert>;
    abstract onLoading(id: any): Observable<Loading>;
}